module.exports = __webpack_public_path__ + "img/i.eb5238be.svg";